import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { environment } from "../../pages/util/baseUrl.js";

const clienteAxios = axios.create({
    baseURL: environment.backendUrl,
    withCredentials: true,
    headers: {
        'X-App-Context': 'ecommerce'
    }
});

const ClienteAuthContext = createContext(null);

export const useClienteAuth = () => {
    return useContext(ClienteAuthContext);
};

export const ClienteAuthProvider = ({ children }) => {
    const [cliente, setCliente] = useState(() => {
        const saved = sessionStorage.getItem('cliente');
        return saved ? JSON.parse(saved) : null;
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const verifyClienteSession = async () => {
            try {
                const response = await clienteAxios.get('/api/auth/cliente/me', {
                    validateStatus: (status) => status >= 200 && status < 500
                });

                if (response.status === 200 && response.data?.id && response.data?.username) {
                    const clienteData = {
                        id: response.data.id,
                        username: response.data.username,
                        nombre: response.data.nombre,
                        userType: 'CLIENTE',
                    };
                    setCliente(clienteData);
                    sessionStorage.setItem('cliente', JSON.stringify(clienteData));
                } else {
                    setCliente(null);
                    sessionStorage.removeItem('cliente');
                }
            } catch (error) {
                if (error.code !== 'ERR_NETWORK') {
                    // Silencioso
                }
                setCliente(null);
                sessionStorage.removeItem('cliente');
            } finally {
                setLoading(false);
            }
        };

        verifyClienteSession();
    }, []);

    const clienteLogin = async (username, password) => {
        const response = await clienteAxios.post('/api/auth/cliente/login', { username, password });
        if (response.status === 200) {
            const clienteData = {
                id: response.data.id,
                username: response.data.username,
                nombre: response.data.nombre,
                userType: 'CLIENTE',
            };
            setCliente(clienteData);
            sessionStorage.setItem('cliente', JSON.stringify(clienteData));
            return clienteData;
        }
        throw new Error('Error en la autenticación.');
    };

    const clienteRegister = async (formData) => {
        const response = await clienteAxios.post('/api/auth/cliente/register', formData);
        if (response.status === 200) {
            const clienteData = {
                id: response.data.id,
                username: response.data.username,
                nombre: response.data.nombre,
                userType: 'CLIENTE',
            };
            setCliente(clienteData);
            sessionStorage.setItem('cliente', JSON.stringify(clienteData));
            return clienteData;
        }
        throw new Error('Error en el registro.');
    };

    const clienteLogout = async () => {
        try {
            await clienteAxios.post('/api/auth/cliente/logout');
        } catch (error) {
            // Silencioso
        } finally {
            setCliente(null);
            sessionStorage.removeItem('cliente');
        }
    };

    const value = {
        cliente,
        loading,
        clienteLogin,
        clienteRegister,
        clienteLogout,
        clienteAxios
    };

    return <ClienteAuthContext.Provider value={value}>{children}</ClienteAuthContext.Provider>;
};
